<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import util from '@/libs/util.js'
// App.vue
export default {
  name: 'app',
  created() {
    this.initMenu();
  },
  methods: {
    async initMenu() {
      const token = util.cookies.get('token'); // 或 localStorage.getItem('token')

      // 如果没有 token，说明未登录，无需加载菜单
      if (!token) {
        return;
      }

      try {
        // ✅ 已登录，尝试获取菜单
        const menuRes = await this.$axios.get('/api-30216/api/user/menus');
        if (menuRes.code === 200) {
          const formattedMenu = this.formatMenuData(menuRes.data);
          this.$store.commit('d2adminMenuAsideSet', formattedMenu);
        }
      } catch (error) {
        console.error('自动加载菜单失败', error);
        // 可选择清空 token，跳转登录页
        // util.cookies.remove('token');
        // this.$router.push({ path: '/login' });
      }
    },

    // 提取 formatMenuData 或从 methods 引用
    formatMenuData(data) {
      const defaultIcon = 'folder-o';
      const result = [];
      function traverse(list) {
        if (!list || !Array.isArray(list)) return;
        list.forEach(item => {
          if (item.type === 1) {
            // 处理目录类型，作为父菜单
            const menuItem = {
              path: item.path,
              title: item.name,
              icon: item.icon || defaultIcon
            };
            // 处理子菜单
            if (item.children && Array.isArray(item.children)) {
              const validChildren = [];
              item.children.forEach(child => {
                if (child.type === 2) {
                  const childItem = {
                    path: child.path,
                    title: child.name,
                    icon: child.icon || defaultIcon
                  };
                  validChildren.push(childItem);
                }
              });
              if (validChildren.length > 0) {
                menuItem.children = validChildren;
                result.push(menuItem);
              }
            }
          } else if (item.type === 2) {
            // 处理菜单类型
            const menuItem = {
              path: item.path,
              title: item.name,
              icon: item.icon || defaultIcon
            };
            // 处理二级菜单
            if (item.children && Array.isArray(item.children)) {
              const validChildren = [];
              item.children.forEach(child => {
                if (child.type === 2) {
                  const childItem = {
                    path: child.path,
                    title: child.name,
                    icon: child.icon || defaultIcon
                  };
                  validChildren.push(childItem);
                }
              });
              if (validChildren.length > 0) {
                menuItem.children = validChildren;
              }
            }
            result.push(menuItem);
          }
        });
      }
      traverse(data);
      console.log('格式化后的菜单数据:', result);
      return result;
    }
  }
};
</script>

<style lang="scss">
@import '~@/assets/style/public-class.scss';

</style>
